import http from "./HttpService";
import { API_BASE_CONTENT, API_BASE_CAMPAIGN } from "../../constants/index";
import { getQueryEmailId } from "modules/EmailBrowser/utils";
import axios from "axios";

export function addingCuratedContentUrlService(link: string) {
  /* adding content by url in development */
  let versionId = getQueryEmailId();
  var data = new FormData();
  data.append("url", link.toString());
  data.append("version_id", "" + versionId);

  return http.post(`${API_BASE_CONTENT}add_article_by_url/`, data, {});
}

export function uploadArticleByFileService(payload: any) {
  let formData = new FormData();
  let versionId = getQueryEmailId();
  formData.append("version_id", versionId.toString());
  formData.append("pdf_filename", payload.filename);
  formData.append("chunk_ids", JSON.stringify(payload.chunkIds));
  return http.post(`${API_BASE_CONTENT}add_article_by_file/`, formData, {});
}

export function uploadFileService(payload: any) {
  let formData = new FormData();
  formData.append("filename", payload.filename);
  formData.append("index", payload.index);
  formData.append("data", payload.data);
  return http.post(`${API_BASE_CONTENT}upload_file_chunks/`, formData, {});
}
export function saveUpdatedTemplateStyleService(templateId: number, versionId: number) {
  let formData = new FormData();
  formData.append("template_id", templateId.toString());
  formData.append("version_id", versionId.toString());
  return http.post(`${API_BASE_CONTENT}change_template/`, formData, {});
}

export function updateArticleOrderService(versionId: any, articleIdsString: string) {
  let formData = new FormData();
  formData.append("version_id", versionId);
  formData.append("article_ids", articleIdsString);
  return http.post(`${API_BASE_CAMPAIGN}reorder_articles/`, formData, {});
}
export function updateEditionSubjectService(versionId: number, subject: string) {
  let formData = new FormData();
  formData.append("email_id", versionId.toString());
  formData.append("email_name", subject.toString());
  return http.post(`${API_BASE_CAMPAIGN}update_version/`, formData, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export function activateAssetService(assetId: string, activeStatus: string) {
  var formData = new FormData();
  formData.append("asset_id", assetId);
  formData.append("activate", activeStatus);
  return http.post(`${API_BASE_CAMPAIGN}activate_asset/`, formData, {});
}

let cancelTokenGetTemplates: any;
export function getTemplatesService(data: any) {
  if (typeof cancelTokenGetTemplates != typeof undefined) {
    cancelTokenGetTemplates && cancelTokenGetTemplates.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenGetTemplates = axios.CancelToken.source();

  return http.get(
    `${API_BASE_CAMPAIGN}get_templates/?limit=${data.limit}&previous_count=${data.offset}&template_type=${data.templateType}&search_string=${data.searchValue}`,
    { cancelToken: cancelTokenGetTemplates.token }
  );
}

export async function getEditionArticlesService(versionId: any) {
  return await http.get(API_BASE_CAMPAIGN + `get_draft_version_content/?version_id=${versionId}`, {});
}

export function updateEditionNameService(versionId: number, name: string) {
  let formData = new FormData();
  formData.append("version_id", versionId.toString());
  formData.append("name", name);
  return http.post(`${API_BASE_CAMPAIGN}update_version/`, formData, {});
}
export function getAssetReminderService(assetId: string) {
  return http.get(`${API_BASE_CAMPAIGN}asset_reminder/?asset_id=${assetId}`, {});
}

export function postAssetReminderService(data: any) {
  var formData = new FormData();
  formData.append("asset_id", data.assetId);
  formData.append("frequency", data.frequency);
  formData.append("frequency_mode", data.frequencyMode);
  formData.append("weekday", data.weekday);
  formData.append("reminder_time", data.reminderTime);
  formData.append("curation_reminder", data.curationReminder);
  formData.append("remind_before", data.remindBefore);
  formData.append("is_active", data.isActive);
  return http.post(`${API_BASE_CAMPAIGN}asset_reminder/`, formData, {});
}
